import ServiceBus from 'servicestack/service-bus'

class DashboardTopSalesRepsController  {
    constructor(createAutoQuery, $session) {
        this.$session = $session;
    }

    load() {
        let $ctrl = this;
        var bus = new ServiceBus();
        var request = {
            reportName: "DashboardSalesByRepGroupBySalesRep",
            dateRange: "YTD",
            status: "Open,Review,Completed,On Hold"
        }
        bus.send('RunReport.json', request).then(function (response) {
            $ctrl.query = response.data; 
        });
    }
}

class DashboardTopSalesReps{
    constructor(){
        this.bindings= {
            date: '@',
        };
        this.controller = DashboardTopSalesRepsController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'dashboard-top-salesreps.html'
    }
}

angular.module('emun.shopping.admin').component('dashboardTopSalesReps', new DashboardTopSalesReps());

export default DashboardTopSalesReps